<template>
    <div>
        <!-- Modal init societe -->
        <modal name="modal-init-societe" height="auto" :scrollable="true" width="700px" :adaptive="true">
            <div class="p-6">

                <h2 class="text-xl font-bold mb-6">Initialiser une nouvelle société</h2>

                <!-- SOCIÉTÉ -->
                <div class="bg-gray-50 p-4 rounded-lg mb-6">
                    <h3 class="font-semibold mb-3">Informations société</h3>

                    <div class="grid grid-cols-2 gap-4">
                        <div>
                            <input id="inp-societe_nom" v-model="form.societe_nom" type="text" placeholder="Nom société" class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm" />
                        </div>
                        <div>
                            <input id="inp-societe_siret" v-model="form.societe_siret" type="text" placeholder="SIRET" class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm" />
                            <div class="mt-1">
                                <a class="text-xs font-light text-blue-500 hover:underline cursor-pointer" href="https://pappers.fr" target="_blank"><i class="fas fa-search mr-1"></i> Rechercher sur pappers</a>
                            </div>
                        </div>

                        <div class="col-span-2">
                            <adresse-form v-model="newAdresse" :min="true" />
                        </div>

                        <div>
                            <label class="text-xs text-gray-500">Heure ouverture</label>
                            <input id="inp-heure_ouverture" v-model="form.societe_heure_ouverture" type="time" class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm" />
                        </div>

                        <div>
                            <label class="text-xs text-gray-500">Heure fermeture</label>
                            <input id="inp-heure_fermeture" v-model="form.societe_heure_fermeture" type="time" class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm" />
                        </div>

                    </div>
                </div>

                <!-- RESPONSABLE -->
                <div class="bg-gray-50 p-4 rounded-lg mb-6">
                    <h3 class="font-semibold mb-3">Compte administrateur</h3>

                    <div class="grid grid-cols-2 gap-4">
                        <input id="inp-prenom_admin" v-model="form.prenom_admin" type="text" placeholder="Prénom" class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm" />
                        <input id="inp-nom_admin" v-model="form.nom_admin" type="text" placeholder="Nom" class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm" />
                        <input id="inp-email_admin" v-model="form.email_admin" type="email" placeholder="Email" class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm col-span-2" />
                    </div>
                </div>

                <!-- Abonnement -->
                <div class="bg-gray-50 p-4 rounded-lg mb-6">
                    <h3 class="font-semibold mb-3">Abonnement</h3>
                    <div class="flex items-center space-x-4">
                        <select id="inp-societe_abonnement" v-model="form.solo" class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm">
                            <option :value="0">Entreprise</option>
                            <option :value="1">Indépendant (1 compte)</option>
                        </select>
                    </div>
                    <div class="mt-4">
                        <label class="flex items-center space-x-2">
                            <input type="checkbox" v-model="form.has_relance">
                            <span class="text-sm">Possède les relances automatiques</span>
                        </label>
                    </div>
                    <div class="mt-2">
                        <label class="flex items-center space-x-2">
                            <input type="checkbox" v-model="form.has_portail">
                            <span class="text-sm">Possède le portail client</span>
                        </label>
                    </div>
                </div>

                <!-- ACTIVITÉS -->
                <div class="bg-gray-50 p-4 rounded-lg mb-6">
                    <h3 class="font-semibold mb-3">Activités</h3>

                    <div class="grid grid-cols-2 gap-2">
                        <label v-for="activite in activites" :key="activite.name" class="flex items-center space-x-2">
                            <input type="checkbox" v-model="form.activites" :value="activite.name">
                            <span class="text-sm">{{ activite.libelle }}</span>
                        </label>
                    </div>
                </div>

                <!-- ACTIONS -->
                <div class="flex justify-end space-x-2">
                    <button @click="$modal.hide('modal-init-societe')" class="px-4 py-2 bg-gray-200 rounded-lg">
                        Annuler
                    </button>

                    <button @click="initSociete" :disabled="loadingInit" class="px-4 py-2 bg-orange-600 text-white rounded-lg">
                        <span v-if="loadingInit"><i class="fas fa-spinner fa-spin mr-1"></i>Création...</span>
                        <span v-else>Créer la société</span>
                    </button>
                </div>

            </div>
        </modal>


        <admin-template>
            <div class="container mx-auto px-4 py-8">
                <h1 class="text-3xl font-bold mb-6">Gestion des sociétés</h1>

                <!-- LOADER -->
                <div v-if="loadingGetData" class="flex flex-col items-center justify-center py-12">
                    <div class="w-16 h-16 border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin"></div>
                    <p class="mt-6 text-gray-700 font-medium text-lg">Chargement des sociétés...</p>
                </div>

                <div v-if="!loadingGetData" class="">

                    <button @click="$modal.show('modal-init-societe')" class="bg-orange-600 text-white px-4 py-2 rounded-lg mb-6">
                        <i class="fas fa-plus mr-1"></i> Ajouter une société
                    </button>

                    <!-- FILTRES -->
                    <div class="bg-white rounded-lg shadow mb-6 p-4">
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">

                            <div>
                                <label class="block text-sm font-medium text-gray-700 mb-1">
                                    Recherche
                                </label>
                                <input
                                    v-model="filters.search"
                                    @input="sendSearchInp"
                                    type="text"
                                    placeholder="Nom société, SIRET, email account..."
                                    class="w-full border border-gray-300 rounded-lg px-3 py-2"
                                />
                            </div>

                            <div class="flex items-end">
                                <button
                                    @click="resetFilters"
                                    class="w-full bg-gray-100 hover:bg-gray-200 px-4 py-2 rounded-lg"
                                >
                                    Retirer les filtres
                                </button>
                            </div>

                        </div>
                    </div>

                    <!-- TABLE -->
                    <div class="overflow-x-auto bg-white rounded-lg shadow">
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead class="bg-gray-50">
                                <tr>
                                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Société</th>
                                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Contact</th>
                                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">SMS</th>
                                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Nb Interventions</th>
                                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Abonnement</th>
                                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Créée le</th>
                                </tr>
                            </thead>

                            <tbody class="bg-white divide-y divide-gray-200">
                                <tr v-if="!societes.length">
                                    <td colspan="5" class="px-6 py-4 text-center text-sm text-gray-500">
                                        Aucune société trouvée.
                                    </td>
                                </tr>

                                <tr @click="$router.push({ name: 'AdminSocietesView', params: { id: societe.id } })" v-for="societe in societes" :key="societe.id" class="hover:bg-red-50 duration-200 cursor-pointer">
                                    
                                    <!-- NOM -->
                                    <td class="px-6 py-4">
                                        <div class="text-sm font-bold text-gray-900">
                                            {{ societe.nom }}
                                        </div>
                                        <div class="text-xs text-gray-500">
                                            {{ societe.ville }} {{ societe.code_postal }}
                                        </div>
                                        <div class="text-xs text-gray-400">
                                            {{ societe.siret || 'Aucun siret' }}
                                        </div>
                                    </td>

                                    <!-- RESPONSABLE -->
                                    <td class="px-6 py-4 text-sm text-gray-600">
                                        <div>
                                            {{ societe.responsable_prenom }} {{ societe.responsable_nom }}
                                        </div>
                                        <div class="text-xs text-gray-500">
                                            {{ societe.mail }}
                                        </div>
                                        <div v-if="societe.accounts && societe.accounts.length" class="text-xs text-gray-400 mt-1">
                                            {{ societe.accounts.length }} compte{{ societe.accounts.length > 1 ? 's' : '' }}
                                        </div>
                                    </td>

                                    <!-- SMS -->
                                    <td class="px-6 py-4 text-sm font-semibold">
                                        <span :class="societe.sms_credits <= 5 ? 'text-red-600' : 'text-gray-900'">
                                            {{ societe.sms_credits }}
                                        </span>
                                    </td>

                                    <!-- INTERVENTIONS -->
                                    <td class="px-6 py-4 text-sm text-gray-600">
                                        {{ societe.interventions_count || 0 }}
                                    </td>

                                    <!-- ABONNEMENT -->
                                    <td class="px-6 py-4 text-sm text-gray-600">
                                        {{ societe.solo ? 'Indépendant' : 'Entreprise' }}
                                    </td>

                                    <!-- DATE -->
                                    <td class="px-6 py-4 text-sm text-gray-500">
                                        {{ new Date(societe.created_at).toLocaleDateString() }}
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- PAGINATION -->
                    <div v-if="pagination.last_page > 1" class="flex items-center justify-between px-6 py-4 bg-gray-50 border-t">

                        <div class="text-sm text-gray-600">
                            {{ pagination.total }} sociétés
                        </div>

                        <div class="flex items-center space-x-1">
                            <button
                                @click="changePage(pagination.current_page - 1)"
                                :disabled="pagination.current_page === 1"
                                class="px-3 py-1 rounded border text-sm disabled:opacity-50"
                            >
                                <i class="fas fa-chevron-left"></i>
                            </button>

                            <button
                                v-for="page in pagination.last_page"
                                :key="page"
                                @click="changePage(page)"
                                :class="page === pagination.current_page ? 'bg-blue-600 text-white' : 'bg-white text-gray-700 hover:bg-gray-100'"
                                class="px-3 py-1 rounded border text-sm"
                            >
                                {{ page }}
                            </button>

                            <button
                                @click="changePage(pagination.current_page + 1)"
                                :disabled="pagination.current_page === pagination.last_page"
                                class="px-3 py-1 rounded border text-sm disabled:opacity-50"
                            >
                                <i class="fas fa-chevron-right"></i>
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </admin-template>
    </div>
</template>

<script>
import AdresseForm from '../../Client/Components/AdresseForm.vue';

export default {
    components: {
        AdresseForm
    },
    data() {
        return {
            societes: [],

            filters: {
                search: ''
            },

            pagination: {
                current_page: 1,
                last_page: 1,
                per_page: 20,
                total: 0,
            },

            timerSendSearchInp: null,
            loadingGetData: false,

            newAdresse: {
                adresse1: '',
                code_postal: '',
                ville: '',
                pays: 'France'
            },

            form: {
                societe_nom: '',
                societe_siret: '',
                societe_adresse: '',
                societe_code_postal: '',
                societe_ville: '',
                societe_pays: 'France',
                societe_heure_ouverture: '08:00',
                societe_heure_fermeture: '18:00',
                prenom_admin: '',
                nom_admin: '',
                email_admin: '',
                activites: [],
                solo: false,
                has_relance: false,
                has_portail: false,
            },

            activites: [
                { name: 'bruleurs', libelle: 'Brûleurs' },
                { name: 'chaudieres', libelle: 'Chaudières' },
                { name: 'chauffeBains', libelle: 'Chauffe-bains' },
                { name: 'climExterieurs', libelle: 'Clim - Unités extérieures' },
                { name: 'climInterieurs', libelle: 'Clim - Unités intérieures' },
                { name: 'pacExterieurs', libelle: 'PAC - Unités extérieures' },
                { name: 'pacInterieurs', libelle: 'PAC - Unités intérieures' },
                { name: 'regulations', libelle: 'Régulations' },
                { name: 'thermodynamiques', libelle: 'Chauffe-eau thermodynamique' },
            ],

            loadingInit: false,
        }
    },

    methods: {

        async getSocietes(page = 1, loader = true) {

            if (loader) this.loadingGetData = true

            let response = await this.$request.post(
                '/admin/societes',
                {
                    search: this.filters.search,
                    page: page,
                    per_page: this.pagination.per_page,
                }
            )

            this.societes = response.data
            this.pagination.current_page = response.current_page
            this.pagination.last_page = response.last_page
            this.pagination.per_page = response.per_page
            this.pagination.total = response.total

            this.loadingGetData = false
        },

        changePage(page) {
            if (page < 1 || page > this.pagination.last_page) return
            this.getSocietes(page)
        },

        resetFilters() {
            this.filters.search = ''
            this.getSocietes(1)
        },

        sendSearchInp() {
            clearTimeout(this.timerSendSearchInp)
            this.timerSendSearchInp = setTimeout(() => {
                this.getSocietes(1, false)
            }, 600)
        },

        async initSociete() {
            const validation = this.$inpError([
                'inp-societe_nom:required|min=3',
                'inp-societe_siret:required|siret',
                'inp-adresse1:required|min=5',
                'inp-code_postal:required|postal',
                'inp-ville:required|min=2',
                'inp-pays:required|min=2',
                'inp-heure_ouverture:required',
                'inp-heure_fermeture:required',
                'inp-prenom_admin:required|min=2',
                'inp-nom_admin:required|min=2',
                'inp-email_admin:required|email',
                'inp-societe_abonnement:required',
            ])

            if (!validation) {
                this.$toast.error('Formulaire invalide')
                return
            }

            // Validation logique métier
            if (this.form.activites.length === 0) {
                this.$toast.error('Sélectionner au moins une activité')
                return
            }

            if (this.form.societe_heure_ouverture >= this.form.societe_heure_fermeture) {
                this.$toast.error("L'heure de fermeture doit être après l'ouverture")
                return
            }


            this.loadingInit = true
            this.form.solo = this.form.solo ? 1 : 0
            this.form.has_relance = this.form.has_relance ? 1 : 0
            this.form.has_portail = this.form.has_portail ? 1 : 0
            this.form.societe_adresse = this.newAdresse.adresse1
            this.form.societe_code_postal = this.newAdresse.code_postal
            this.form.societe_ville = this.newAdresse.ville
            this.form.societe_pays = this.newAdresse.pays

            let response = await this.$request.post('/admin/societes/init', {
                ...this.form,
                activites: JSON.stringify(this.form.activites)
            })

            this.loadingInit = false

            if (response.error) {
                this.$toast.error(response.error)
                return
            }

            this.$toast.success('Société créée avec succès')

            this.$modal.hide('modal-init-societe')

            this.$router.push({ name: 'AdminSocieteView', params: { id: response.societe_id } })

            this.getSocietes(1)

            // reset form
            Object.keys(this.form).forEach(key => {
                if (Array.isArray(this.form[key])) this.form[key] = []
                else this.form[key] = ''
            })
        }
    },

    mounted() {
        this.getSocietes()
    }
}
</script>
